import { observer } from 'mobx-react-lite'
import { PromoteToOwnerDialog } from '@/features/user-management/PromoteToOwnerDialog'
import { type PromoteToOwnerDialogViewModel } from './PromoteToOwnerDialogViewModel'

export interface PromoteToOwnerDialogContainerProps {
  vm: PromoteToOwnerDialogViewModel
}

export const PromoteToOwnerDialogContainer = observer(
  function PromoteToOwnerDialogContainer({
    vm,
  }: PromoteToOwnerDialogContainerProps) {
    return (
      <PromoteToOwnerDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        workspaceName={vm.workspace.name}
        onPromote={vm.promote}
        isPromotePending={vm.promote.pending}
      />
    )
  },
)
